import { useContext } from "react";
import NotificationContext from "../contexts/Notification";

export const useNotificationContext = () => useContext(NotificationContext);
